module.exports = __webpack_public_path__ + "img/nano.6eedd591.svg";